import { commonFilter } from './filter';

export default {
  pageName: 'DataMapOpinionsSources',
  pageId: '20030',
  pagePath: '/opinion/DataMap/OpinionsSources',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
